import classNames from 'classnames';
import { Button, Stack } from 'src/viewLayer/components/DesignSystem';

import {
  trackGuiInteracted,
  trackGuiShown
} from 'src/dataLayer/remoteData/babbelEventStream';
import { RUNTIME_ENVIRONMENT } from 'src/dataLayer/env';
import { t } from 'src/viewLayer/helpers/translations';
import type { ButtonSectionPropsType } from '../types';


const GUI_SNIPER_ELEMENT = 'sniper_email_verification_page';

const showSniperLink = (email: string): (string | undefined) => {
  if (email?.length === 0) return undefined;
  if (/@gmail|googlemail|google\.com/.test(email)) return 'gmail';
  return undefined;
};

const buildSniperLink = (email: string): string => {
  const sender = RUNTIME_ENVIRONMENT === 'production'
    ? 'verification@settings.babbel.com'
    : 'system@members.babbel.cn';
  return `https://mail.google.com/mail/u/${email}/#search/` +
  `from%3A${encodeURIComponent(sender)}+in%3Aanywhere+newer_than%3A1d`;
};

export default ({
  userEmail,
  continueHandler,
  button,
  showContinueButton
}: ButtonSectionPropsType): JSX.Element => {
  const sniperLink = showSniperLink(userEmail);
  const trackedSniperLinkHandler = (): void => {
    trackGuiInteracted({ guiElementName: GUI_SNIPER_ELEMENT, guiVariantName: 'email_redirect' });
    window.open(buildSniperLink(userEmail), '_blank').focus();
  };

  if (sniperLink) {
    trackGuiShown({ guiElementName: GUI_SNIPER_ELEMENT });
  }

  return (
    <Stack gap={24} align="center" alignItems="center">
      { showContinueButton &&
        <Button
          onClick={ continueHandler }
          className="continueButton"
          id="continue"
          minWidth="90%"
        >
          { t(button?.key || 'common.navigation.button.continue') }
        </Button>
      }
      { sniperLink &&
        <Button
          data-testid={sniperLink}
          className={classNames('sniper', sniperLink)}
          color="secondary"
          onClick={ trackedSniperLinkHandler }
        >
          { t(`pages.evp.verification_account_created.button.${sniperLink}`) }
        </Button>
      }
    </Stack>
  );
};
